import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import QueryString from "qs";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { ReqMethods, ghl } from "enums";
import env from "config/env";
import useRequest from "hook/useRequest";
import { useAgencyInfo } from "context/agency";

function GHL() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const code = new URLSearchParams(search).get("code");
  const type = new URLSearchParams(search).get("type");
  const agency = new URLSearchParams(search).get("state");
  const request = useRequest();
  const queryClient = useQueryClient();

  const associate = async (creds) => {
    var payload = {
      _id: agency,
      account_ghl: {
        location_id: creds.locationId,
        company_id: creds.companyId,
        access_token: creds.access_token,
        refresh_token: creds.refresh_token,
      },
    };

    const { response } = await request(ReqMethods.PUT, "/brand", { payload });

    if (!response) throw new Error("Something went wrong while integration, please try latter");
    return "Location Connect Successfully";
  };

  const getCreds = async () => {
    const payload = {
      method: ReqMethods.POST,
      path: ghl.APIs.oauth,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      payload: QueryString.stringify({
        client_id: env.GHL.ACCOUNT_CLIENT_ID,
        client_secret: env.GHL.ACCOUNT_CLIENT_SECRET,
        grant_type: "authorization_code",
        code,
        refresh_token: "",
      }),
    };
    const { response } = await request(ReqMethods.POST, "/services/ghl/", { payload });

    if (!response) throw new Error("Something went wrong while integration, please try latter");
    // if(location_id !== response.data.locationId) return setError('location ID mismatch')
    return associate(response.data);
  };

  const { mutate, data, error, isError } = useMutation({
    mutationFn: getCreds,
    // The GHL auth `code` is single-use, so this is a one-shot action, not a
    // cacheable read - it's triggered once on mount below, never refetched.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["agency"] }),
  });

  useEffect(() => {
    mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const done = isError || !!data;

  return (
    <SoftBox>
      {!done && <SoftBox>Integrating please wait...</SoftBox>}
      {done && (
        <SoftBox>
          {isError ? error.message : data}
          <SoftButton onClick={() => navigate(-2)}>Go Back</SoftButton>
        </SoftBox>
      )}
    </SoftBox>
  );
}

export default GHL;
